import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=308b7754&scoped=true"
import script from "./CustomerInfo.vue?vue&type=script&lang=ts"
export * from "./CustomerInfo.vue?vue&type=script&lang=ts"
import style0 from "./CustomerInfo.vue?vue&type=style&index=0&id=308b7754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308b7754",
  null
  
)

export default component.exports